/*kiwi/build/maptype*/
function _(require, module, exports) {
    var tsu_1 = require(346    /* ./tsu */);
    function createMap(compare) {
        return new tsu_1.AssociativeArray(compare);
    }
    exports.createMap = createMap;
}